import {
  Breakpoint,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import React from 'react';

interface GenericDialogProps {
  fullWidth?: boolean;
  dialogActions?: React.ReactNode;
  children: React.ReactNode;
  maxWidth?: Breakpoint | 'xxl' | false;
  onClose?: () => void;
  open: boolean;
  title?: string;
}

const GenericDialog = ({
  fullWidth = true,
  dialogActions,
  children,
  maxWidth,
  open,
  onClose,
  title,
}: GenericDialogProps) => {
  return (
    <Dialog
      fullWidth={fullWidth}
      open={open}
      onClose={onClose}
      maxWidth={(maxWidth ?? 'lg') as Breakpoint}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{children}</DialogContent>
      {dialogActions && (
        <DialogActions sx={{ px: 3, pb: 2 }}>{dialogActions}</DialogActions>
      )}
    </Dialog>
  );
};

export default GenericDialog;
